import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MatDialog,
} from '@angular/material/dialog'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { MatIcon } from '@angular/material/icon'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { TableListTariffSelectComponent } from '../../../shared/components/table-list-tariff-select/table-list-tariff-select.component'
import {
  convertCurrency,
  removeAccentsAndSpacesAndLowercase,
} from '../../../shared/utils/utils'
import { apenasParadasP } from '../../../shared/utils/parada-itinerario.util'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { LocationService } from '../../../core/services/location/location/location.service'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { ModalGoogleMapsComponent } from '../../address/modal-google-maps/modal-google-maps.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { CommonModule } from '@angular/common'
import { distinctUntilChanged, Observable } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { EstadoCidade, estadosCidades } from '../../../core/models/addressIBGE'

import { of } from 'rxjs'
import { concatMap } from 'rxjs/operators'

interface LocationModel {
  id: number
  descricao: string
}

@Component({
  selector: 'search-tariff-proposal',
  imports: [
    CommonModule,
    MatProgressBar,
    PaginationComponent,
    TableListTariffSelectComponent,
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatInput,
    MatIcon,
    MatAutocompleteModule,
  ],
  templateUrl: './search-tariff-proposal.component.html',
  styleUrl: './search-tariff-proposal.component.scss',
  standalone: true,
  providers: [
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    TariffService,
    TariffTypeService,
    ViaCepService,
  ],
})
export class SearchTariffProposalComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private tariffTypeService: TariffTypeService,
    private viaCepService: ViaCepService,
    private tariffService: TariffService,
    private dialog: MatDialog,
  ) {
    this.createForm()
  }

  filteredOrigins!: Observable<LocationModel[]>
  filteredDestinations!: Observable<LocationModel[]>

  item: any = { user: false, data: [] }
  multiSelect = false
  tableView = false
  isBlocked = false

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()
  @Output() selectItemEvent = new EventEmitter()
  @Output() locationEvent = new EventEmitter()
  @Output() loadingEnd = new EventEmitter()

  @Input() tariffSelected: any = {}
  @Input() proposal: any = {}
  @Input() edit = false
  @Input() viewOnly = false
  @Input() idClient = 0

  stateCity: EstadoCidade[] = estadosCidades

  isFillingForm = false

  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTariffType: any[] = []
  listTypeService: any[] = []
  listStandard: any[] = [
    { value: 'T', description: 'Ambos' },
    { value: 'S', description: 'Sim' },
    { value: 'N', description: 'Não' },
  ]
  listPerimeter: any[] = [
    { value: 'T', description: 'Ambos' },
    { value: 'S', description: 'Sim' },
    { value: 'N', description: 'Não' },
  ]

  listServiceSpecification: any[] = []

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  searchForm = {}
  inputSearch = ''

  form: FormGroup = new FormGroup({})
  formOrigin: FormGroup = new FormGroup({})
  formDestination: FormGroup = new FormGroup({})

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'typeTariff',
      key: 'tipoTarifario',
      // key: 'tipo',
      description: 'Tipo',
    },
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost',
      key: 'custo_formatado',
      description: 'Custo',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'custo_formatado',
      description: 'Custo Extra',
    },
    {
      keyColumn: 'infoTariff',
      key: 'perimetroUrbano',
      description: 'Infos',
    },
    {
      keyColumn: 'validity',
      key: 'dataValidade',
      description: 'validade',
    },
  ]

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false

  listSpecificationService: any[] = []

  ngOnInit(): void {
    // Inicia o encadeamento de chamadas com `of(null)`
    of(null)
      .pipe(
        // 1. Busca todas as especificações de serviço primeiro
        concatMap(() =>
          this.serviceSpecificationService.listServiceSpecification(),
        ),
        // 2. Depois que a primeira requisição terminar, busca os locais
        concatMap((response: ResponseRequestModel) => {
          this.listSpecificationService = response.data ?? []
          return this.locationService.listLocation()
        }),
        // 3. Depois, busca os tipos de serviço
        concatMap((response: ResponseRequestModel) => {
          this.listLocation = response.data
          // Se `tariffSelected` e `id` existirem, preenche o formulário
          if (this.selected && this.selected.id) {
            this.fillForm(false, true)
            this.blockFields(true)
          }
          return this.serviceTypeService.listServiceType()
        }),
        // 4. E assim por diante, para cada serviço
        concatMap((response: ResponseRequestModel) => {
          this.listTypeService = response.data
          return this.vehicleTypeService.listVehicleType()
        }),
        concatMap((response: ResponseRequestModel) => {
          this.listTypeVehicle = response.data
          return this.driverTypeService.listDriverType()
        }),
        concatMap((response: ResponseRequestModel) => {
          this.listTypeDriver = response.data
          return this.tariffTypeService.listTariffType()
        }),
      )
      .subscribe({
        next: (response: ResponseRequestModel) => {
          // O `response` aqui é o resultado da *última* chamada (getTypeTariff)
          this.listTariffType = response.data
          this.loadingEnd.emit(true)
        },
        error: (err) => {
          console.error('Um erro ocorreu durante o carregamento de dados:', err)
        },
      })
    if (this.tariffSelected && this.tariffSelected.id) {
      this.fillForm(false, true)
      this.blockFields(true)
    }
    if (this.viewOnly) {
      this.blockFields(true)
    }
  }

  // ngOnInit() {
  //   // this.getListItems()
  //   this.getServiceSpecificationAll()
  //   this.getLocation()
  //   this.getTypeService()
  //   this.getTypeVehicle()
  //   this.getTypeDriver()
  //   this.getTypeTariff()
  //   // this.createForm()
  //   if (this.tariffSelected && this.tariffSelected.id) {
  //     this.fillForm(false, true)
  //     this.blockFields(true)
  //   }
  // }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tariffSelected']) {
      this.selected = this.tariffSelected
      // if (this.listLocation.length > 0) {
      //   // Se já temos a lista de locais, atualiza imediatamente
      //   this.updateFormValues();
      // }
      if (this.tariffSelected != this.selected) {
        this.selected = this.tariffSelected
        if (this.selected.id) {
          this.fillForm(false, true)
          this.blockFields(true)
        }
      }
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      // origin: ['', [Validators.required]],
      // destination: ['', [Validators.required]],
      tariffType: [1, [Validators.required]],
      serviceType: ['', [Validators.required]],
      specificationService: ['', [Validators.required]],
      vehicleType: [''],
      driverType: [''],
      // standard: ['T'],
      urbanPerimeter: ['T'],
    })

    this.formOrigin = this.formBuilder.group({
      originPostalCode: [''],
      originStreet: [''],
      originNeighborhood: [''],
      originNumber: [''],
      originComplement: [''],
      // originDesc: [''],
      originLocal: [''],
      originState: [''],
      originCity: [''],
      originLongitude: [''],
      originLatitude: [''],
    })

    this.formDestination = this.formBuilder.group({
      destinationPostalCode: [''],
      destinationStreet: [''],
      destinationNeighborhood: [''],
      destinationNumber: [''],
      destinationComplement: [''],
      destinationCountry: [''],
      // destinationDesc: [''],
      destinationLocal: [''],
      destinationState: [''],
      destinationCity: [''],
      destinationLongitude: [''],
      destinationLatitude: [''],
    })

    // this.monitoringInputs()
  }

  displayLocation = (value: any): string => {
    if (!value) return ''

    // Se for objeto LocationModel
    if (typeof value === 'object' && value.descricao) {
      return value.descricao
    }

    // Se for string (input manual)
    if (typeof value === 'string') return value

    return ''
  }

  monitoringInputs() {
    const debounceMs = 1000
    // Monitorar tanto origem quanto destino
    this.form
      .get('origin')
      ?.valueChanges.pipe(debounceTime(debounceMs), distinctUntilChanged())
      .subscribe((value) => {
        if (this.isFillingForm) return
        if (value && typeof value === 'string' && value.length >= 3) {
          this.filterLocation('origin')
        }
      })

    this.form
      .get('destination')
      ?.valueChanges.pipe(debounceTime(debounceMs), distinctUntilChanged())
      .subscribe((value) => {
        if (value && typeof value === 'string' && value.length >= 3) {
          if (this.isFillingForm) return
          this.filterLocation('destination')
        }
      })

    this.formDestination.valueChanges.subscribe((value) => {
      if (
        this.formDestination.get('destinationState')!.value != '' &&
        this.formDestination.get('destinationState')!.value.length > 2
      ) {
        this.filterLocation('destination')
      }
    })

    this.formOrigin.valueChanges.subscribe((value) => {
      if (
        this.formOrigin.get('originState')!.value != '' &&
        this.formOrigin.get('originState')!.value.length > 2
      ) {
        this.filterLocation('origin')
      }
    })
  }

  filterLocation(type: 'destination' | 'origin') {
    this.getLocationCityState(type)
  }

  onOriginSelected(event: any): void {
    const selected = event.option.value
    // Garante que apenas objetos LocationModel sejam definidos
    if (typeof selected === 'object' && selected.id && selected.descricao) {
      this.form.get('origin')?.setValue(selected, { emitEvent: false })
      this.searchTariff()
    }
  }

  onDestinationSelected(event: any): void {
    const selected = event.option.value
    if (typeof selected === 'object' && selected.id && selected.descricao) {
      this.form.get('destination')?.setValue(selected, { emitEvent: false })
      this.searchTariff()
    }
  }

  getLocation(): void {
    this.locationService.listLocation().subscribe({
      next: (resp: ResponseRequestModel) => {
        this.listLocation = resp.data

        // Inicializa os filtros primeiro
        // this.initOriginFilter()

        if (this.selected && this.selected.id) {
          this.fillForm(false, true)
          this.blockFields(true)
        }
      },
      error: (err) => console.error(err),
    })
  }

  updateFormValues(): void {
    // Origem - aceita tanto objeto quanto ID
    if (this.tariffSelected.origemId) {
      const originItem = this.listLocation.find(
        (c) => c.id === this.tariffSelected.origemId,
      )
      if (originItem) {
        this.form.get('origin')?.setValue(originItem, { emitEvent: false })
      }
    }

    // Destino - aceita tanto objeto quanto ID
    if (this.tariffSelected.destinoId) {
      const destinationItem = this.listLocation.find(
        (c) => c.id === this.tariffSelected.destinoId,
      )
      if (destinationItem) {
        this.form
          .get('destination')
          ?.setValue(destinationItem, { emitEvent: false })
      }
    }
  }

  // initOriginFilter(): void {
  //   this.filteredOrigins = this.form.get('origin')!.valueChanges.pipe(
  //     startWith(''),
  //     map((v) => {
  //       // Se for objeto, retorna a descrição
  //       if (v && typeof v === 'object' && v.descricao) {
  //         return v.descricao
  //       }
  //       if (v && typeof v === 'object' && v.estado) {
  //         return v.estado
  //       }
  //       // Se for string, retorna a string
  //       if (typeof v === 'string') return v
  //       return ''
  //     }),
  //     map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
  //     map((searchText) => {
  //       return this.listLocation.filter((loc) => {
  //         const locDescription = loc?.descricao || ''
  //         const locState = loc?.estado || ''
  //         return (
  //           removeAccents(locDescription.toLowerCase()).includes(searchText) ||
  //           removeAccents(locState.toLowerCase()).includes(searchText)
  //         )
  //       })
  //     }),
  //   )
  //
  //   this.filteredDestinations = this.form.get('destination')!.valueChanges.pipe(
  //     startWith(''),
  //     map((v) => {
  //       if (v && typeof v === 'object' && v.descricao) {
  //         return v.descricao
  //       }
  //       if (v && typeof v === 'object' && v.estado) {
  //         return v.estado
  //       }
  //       if (typeof v === 'string') return v
  //       return ''
  //     }),
  //     map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
  //     map((searchText) => {
  //       return this.listLocation.filter((loc) => {
  //         const locDescription = loc?.descricao || ''
  //         const locState = loc?.estado || ''
  //         return (
  //           removeAccents(locDescription.toLowerCase()).includes(searchText) ||
  //           removeAccents(locState.toLowerCase()).includes(searchText)
  //         )
  //       })
  //     }),
  //   )
  // }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  getTypeTariff() {
    this.tariffTypeService.listTariffType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTariffType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    const specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
    this.searchTariff()
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')!.clearValidators()
    this.form.get('driverType')!.clearValidators()
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
    this.searchTariff()
  }

  getServiceSpecificationAll() {
    this.listSpecificationService = []
    this.serviceSpecificationService.listServiceSpecification().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listSpecificationService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  getServiceSpecification(idType: number, idService = -1) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (idService >= 0) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == idService
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => { },
      })
  }

  checkService(specificationService: any) {
    if (specificationService) {
      if (
        specificationService.exigeVeiculo &&
        specificationService.exigeVeiculo.toLowerCase() == 's'
      ) {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        this.form.get('vehicleType')!.enable()
        this.form.get('driverType')!.enable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  createModel() {
    // const origemId =
    //   typeof this.form.get('origin')?.value == 'object'
    //     ? this.form.get('origin')?.value?.id
    //     : this.form.get('origin')?.value
    //
    // const destinoId =
    //   typeof this.form.get('destination')?.value == 'object'
    //     ? this.form.get('destination')?.value?.id
    //     : this.form.get('destination')?.value

    // const origemId =
    //   typeof this.form.get('origin')?.value == 'object'
    //     ? this.form.get('origin')?.value?.id
    //     : 0
    //
    // const destinoId =
    //   typeof this.form.get('destination')?.value == 'object'
    //     ? this.form.get('destination')?.value?.id
    //     : 0

    return {
      tipoTarifarioId:
        this.form.get('tariffType')!.value != ''
          ? this.form.get('tariffType')!.value
          : 0,
      tarifarioStatus: '',
      origemId: 0,
      origem: '',
      // origemDescricao: this.formOrigin.get('originDesc')!.value,
      origemDescricao: '',
      origemCidade: this.formOrigin.get('originCity')?.value ?? '',
      origemEstado: this.formOrigin.get('originState')?.value ?? '',
      destinoId: 0,
      destino: '',
      // destinoDescricao: this.formDestination.get('destinationDesc')!.value,
      destinoDescricao: '',
      destinoCidade: this.formDestination.get('destinationCity')?.value ?? '',
      destinoEstado: this.formDestination.get('destinationState')?.value ?? '',
      perimetroUrbano: this.form.get('urbanPerimeter')!.value ?? 'T',
      tipoServicoId:
        this.form.get('serviceType')!.value != '' &&
          this.form.get('serviceType')!.value
          ? this.form.get('serviceType')!.value
          : 0,
      tipoServico: '',
      servicoId:
        this.form.get('specificationService')!.value != '' &&
          this.form.get('specificationService')!.value
          ? this.form.get('specificationService')!.value
          : 0,
      servico: '',
      tipoVeiculoId:
        this.form.get('vehicleType')!.value != '' &&
          this.form.get('vehicleType')!.value
          ? this.form.get('vehicleType')!.value
          : 0,
      tipoVeiculo: '',
      tipoMotoristaId:
        this.form.get('driverType')!.value != '' &&
          this.form.get('driverType')!.value
          ? this.form.get('driverType')!.value
          : 0,
      tipoMotorista: '',
      clienteId: this.idClient,
      cliente: '',
      fornecedorId: 0,
      fornecedor: '',
      // standard: this.form.get('standard')!.value ?? 'T',
      standard: 'N',
      // origemId: origemId ?? 0,
      // origem: '',
      // destinoId: destinoId ?? 0,
      // destino: '',
      // tipoServicoId:
      //   this.form.get('serviceType')!.value != ''
      //     ? this.form.get('serviceType')!.value
      //     : 0,
      // tipoServico: '',
      // servicoId:
      //   this.form.get('specificationService')!.value != ''
      //     ? this.form.get('specificationService')!.value
      //     : 0,
      // servico: '',
      // tipoVeiculoId:
      //   this.form.get('vehicleType')!.value != ''
      //     ? this.form.get('vehicleType')!.value
      //     : 0,
      // tipoVeiculo: '',
      // tipoMotoristaId:
      //   this.form.get('driverType')!.value != ''
      //     ? this.form.get('driverType')!.value
      //     : 0,
      // tipoMotorista: '',
      // clienteId: this.idClient,
      // cliente: '',
      // fornecedorId: 0,
      // fornecedor: '',
      // perimetroUrbano: this.form.get('urbanPerimeter')!.value ?? 'T',
      // standard: this.form.get('standard')!.value ?? 'T',
    }
  }

  searchTariff() {
    // if (this.isFillingForm) return;
    this.search(this.createModel())
    this.tableView = true
  }

  search(event: any) {
    const search = event
    this.page = 1
    if (search) {
      this.searchForm = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = {}
    }
    if (this.searchForm) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    const selectedId = this.selected?.id ?? this.tariffSelected?.id
    const restrictToSelected =
      (this.edit || this.viewOnly) &&
      !!selectedId &&
      selectedId !== -1 &&
      selectedId !== ''
    if (response.data && response.data.tarifarios) {
      for (const item of response.data.tarifarios) {
        if (restrictToSelected && item.id != selectedId) continue
        list.push({
          ...item,
          custo_formatado: `R$ ${convertCurrency(item.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(item.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(item.custokmExtra)}`,
          isClient: item.clienteId == this.idClient,
        })
      }
    }
    this.itemsList = list
    this.numberRows = restrictToSelected ? list.length : response.totalItens
    this.ensureSelectedInList()
    this.loadParadasForList()
  }

  // N+1 mantido: o endpoint da lista default (/default/listpaginated) não popula
  // `paradas`; só o /search-paginated. Por isso buscamos o itinerário por tarifário.
  // `apenasParadasP` descarta os trechos O/D, deixando só as paradas reais (P).
  private loadParadasForList(): void {
    for (const item of this.itemsList) {
      if (!item?.id) continue
      this.tariffService.getParadas(item.id).subscribe({
        next: (resp: any) => {
          item.paradas = apenasParadasP(resp?.data)
          this.itemsList = [...this.itemsList]
        },
        error: () => {
          item.paradas = []
        },
      })
    }
  }

  private ensureSelectedInList(): void {
    const selectedId = this.selected?.id ?? this.tariffSelected?.id
    if (!selectedId || selectedId === -1 || selectedId === '') return
    const presente = this.itemsList.some((t) => t.id == selectedId)
    if (presente) return
    this.tariffService.getTariffbyId(selectedId as any).subscribe({
      next: (response: any) => {
        const data = response?.data
        if (!data) return
        const tipoTarifarioDesc =
          data.tipoTarifario ??
          this.listTariffType.find((t) => t.id == data.tipoId)?.descricao ??
          ''
        const item: any = {
          ...data,
          tipoTarifario: tipoTarifarioDesc,
          custo_formatado: `R$ ${convertCurrency(data.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(data.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(data.custokmExtra)}`,
          isClient: data.clienteId == this.idClient,
          paradas: [],
        }
        this.itemsList = [item, ...this.itemsList]
        this.numberRows = (this.numberRows ?? 0) + 1
        this.tariffService.getParadas(item.id).subscribe({
          next: (paradasResp: any) => {
            item.paradas = apenasParadasP(paradasResp?.data)
            this.itemsList = [...this.itemsList]
          },
          error: () => {},
        })
      },
      error: (err) => {
        console.error(err)
      },
    })
  }

  getListItems() {
    this.loading = true
    this.tariffService.listPagedTariff(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => { },
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.tariffService
      .searchPagedTariff(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      const index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { id: -1 }
        this.selectItemEvent.emit(this.selected)
        // this.fillForm(true)
        this.isBlocked = false
        this.blockFields(false)
      } else {
        this.selected = event
        // this.fillForm()
        this.fillForm(false, true)
        this.isBlocked = true
        this.blockFields(true)
        this.selectItemEvent.emit({
          ...this.selected,
          location: this.modelLocation(),
          origin: this.modelLocation('origin'),
          destination: this.modelLocation('destination'),
          isComission: this.getIsComission(event),
        })
      }
    }
  }

  getIsComission(select: any) {
    const specificationService = this.listSpecificationService.find((ele) => {
      return ele.id == select.servicoId
    })
    if (
      specificationService.exigeVeiculo &&
      specificationService.exigeVeiculo.toLowerCase() == 's'
    ) {
      return true
    } else {
      return false
    }
  }

  fillForm(clear = false, search = false) {
    this.isFillingForm = true
    if (!clear) {
      this.blockFields(true)
      let tipo = ''
      if (this.selected.tipoTarifarioId) {
        tipo = this.selected.tipoTarifarioId
      } else if (this.selected.tipoId) {
        tipo = this.selected.tipoId
      }

      if (this.selected.tipoServicoId != this.form.get('serviceType')!.value) {
        this.form
          .get('serviceType')!
          .setValue(this.selected.tipoServicoId ?? '')
        this.getServiceSpecification(this.selected.tipoServicoId)
      }
      // this.updateFormValues();
      // if (this.selected.origemId) {
      //   const originItem = this.listLocation.find(
      //     (loc) => loc.id === this.selected.origemId,
      //   )
      //   if (originItem) {
      //     this.form.get('origin')?.setValue(originItem, { emitEvent: false })
      //   }
      // }

      // if (this.selected.destinoId) {
      //   const destinationItem = this.listLocation.find(
      //     (loc) => loc.id === this.selected.destinoId,
      //   )
      //   if (destinationItem) {
      //     this.form
      //       .get('destination')
      //       ?.setValue(destinationItem, { emitEvent: false })
      //   }
      // }

      this.form
        .get('specificationService')!
        .setValue(this.selected.servicoId ?? '')
      this.form.get('vehicleType')!.setValue(this.selected.tipoVeiculoId ?? '')
      this.form.get('driverType')!.setValue(this.selected.tipoMotoristaId ?? '')
      this.form.get('urbanPerimeter')!.setValue(this.selected.perimetroUrbano)
      // this.form.get('standard')!.setValue(this.selected.standard)
      this.form.get('tariffType')!.setValue(tipo)

      // this.formOrigin.get('originDesc')?.setValue(this.selected.origem)

      this.formOrigin.get('originCity')?.setValue(this.selected.cidadeOrigem)
      this.formOrigin.get('originState')?.setValue(this.selected.estadoOrigem)

      // this.formDestination
      //   .get('destinationDesc')
      //   ?.setValue(this.selected.destino)
      this.formDestination
        .get('destinationCity')
        ?.setValue(this.selected.cidadeDestino)
      this.formDestination
        .get('destinationState')
        ?.setValue(this.selected.estadoDestino)

      if (this.selected.origin) {
        this.formOrigin
          .get('originPostalCode')
          ?.setValue(this.selected.origin.cep)
        this.formOrigin
          .get('originStreet')
          ?.setValue(this.selected.origin.logradouro)
        this.formOrigin
          .get('originNumber')
          ?.setValue(this.selected.origin.numero)
        this.formOrigin
          .get('originComplement')
          ?.setValue(this.selected.origin.complemento)
        this.formOrigin
          .get('originNeighborhood')
          ?.setValue(this.selected.origin.bairro)
        this.formOrigin.get('originCity')?.setValue(this.selected.origin.cidade)
        this.formOrigin
          .get('originState')
          ?.setValue(this.selected.origin.estado)
        this.formOrigin
          .get('originLatitude')
          ?.setValue(this.selected.origin.latitude)
        this.formOrigin
          .get('originLogitude')
          ?.setValue(this.selected.origin.longitude)
        this.formOrigin
          .get('originLocal')
          ?.setValue(this.selected.origin.descricao)
      }

      if (this.selected.destination) {
        this.formDestination
          .get('destinationPostalCode')
          ?.setValue(this.selected.destination.cep)
        this.formDestination
          .get('destinationStreet')
          ?.setValue(this.selected.destination.logradouro)
        this.formDestination
          .get('destinationNumber')
          ?.setValue(this.selected.destination.numero)
        this.formDestination
          .get('destinationComplement')
          ?.setValue(this.selected.destination.complemento)
        this.formDestination
          .get('destinationNeighborhood')
          ?.setValue(this.selected.destination.bairro)
        this.formDestination
          .get('destinationCity')
          ?.setValue(this.selected.destination.cidade)
        this.formDestination
          .get('destinationState')
          ?.setValue(this.selected.destination.estado)
        this.formDestination
          .get('destinationLatitude')
          ?.setValue(this.selected.destination.latitude)
        this.formDestination
          .get('destinationLogitude')
          ?.setValue(this.selected.destination.longitude)
        this.formDestination
          .get('destinationLocal')
          ?.setValue(this.selected.destination.descricao)
      }
    } else {
      this.blockFields(false)
      // this.form.get('origin')!.setValue('')
      // this.form.get('destination')!.setValue('')
      this.form.get('serviceType')!.setValue('')
      this.form.get('specificationService')!.setValue('')
      this.form.get('vehicleType')!.setValue('')
      this.form.get('driverType')!.setValue('')
      this.form.get('urbanPerimeter')!.setValue('T')
      // this.form.get('standard')!.setValue('T')
      this.form.get('tariffType')!.setValue('T')
      this.blockFields()
    }
    if (search) {
      this.searchTariff()
    }
  }

  blockFields(block = false) {
    this.isBlocked = block
    if (block) {
      // this.form.get('origin')!.disable()
      // this.form.get('destination')!.disable()
      this.form.get('serviceType')!.disable()
      this.form.get('specificationService')!.disable()
      this.form.get('vehicleType')!.disable()
      this.form.get('driverType')!.disable()
      this.form.get('urbanPerimeter')!.disable()
      // this.form.get('standard')!.disable()
      this.form.get('tariffType')!.disable()

      this.formOrigin.get('originPostalCode')!.disable()
      this.formOrigin.get('originStreet')!.disable()
      this.formOrigin.get('originNumber')!.disable()
      this.formOrigin.get('originComplement')!.disable()
      this.formOrigin.get('originNeighborhood')!.disable()
      this.formOrigin.get('originCity')!.disable()
      this.formOrigin.get('originState')!.disable()
      this.formOrigin.get('originLatitude')!.disable()
      this.formOrigin.get('originLongitude')!.disable()
      // this.formOrigin.get('originDesc')!.disable()
      this.formOrigin.get('originLocal')!.disable()

      this.formDestination.get('destinationPostalCode')!.disable()
      this.formDestination.get('destinationStreet')!.disable()
      this.formDestination.get('destinationNumber')!.disable()
      this.formDestination.get('destinationComplement')!.disable()
      this.formDestination.get('destinationNeighborhood')!.disable()
      this.formDestination.get('destinationCity')!.disable()
      this.formDestination.get('destinationState')!.disable()
      this.formDestination.get('destinationLatitude')!.disable()
      this.formDestination.get('destinationLongitude')!.disable()
      // this.formDestination.get('destinationDesc')!.disable()
      this.formDestination.get('destinationLocal')!.disable()
    } else {
      // this.form.get('origin')!.enable()
      // this.form.get('destination')!.enable()
      this.form.get('serviceType')!.enable()
      this.form.get('specificationService')!.enable()
      this.form.get('vehicleType')!.enable()
      this.form.get('driverType')!.enable()
      this.form.get('urbanPerimeter')!.enable()
      // this.form.get('standard')!.enable()
      this.form.get('tariffType')!.enable()

      this.formOrigin.get('originPostalCode')!.enable()
      this.formOrigin.get('originStreet')!.enable()
      this.formOrigin.get('originNumber')!.enable()
      this.formOrigin.get('originComplement')!.enable()
      this.formOrigin.get('originNeighborhood')!.enable()
      this.formOrigin.get('originCity')!.enable()
      this.formOrigin.get('originState')!.enable()
      this.formOrigin.get('originLatitude')!.enable()
      this.formOrigin.get('originLongitude')!.enable()
      // this.formOrigin.get('originDesc')!.enable()
      this.formOrigin.get('originLocal')!.enable()

      this.formDestination.get('destinationPostalCode')!.enable()
      this.formDestination.get('destinationStreet')!.enable()
      this.formDestination.get('destinationNumber')!.enable()
      this.formDestination.get('destinationComplement')!.enable()
      this.formDestination.get('destinationNeighborhood')!.enable()
      this.formDestination.get('destinationCity')!.enable()
      this.formDestination.get('destinationState')!.enable()
      this.formDestination.get('destinationLatitude')!.enable()
      this.formDestination.get('destinationLongitude')!.enable()
      // this.formDestination.get('destinationDesc')!.enable()
      this.formDestination.get('destinationLocal')!.enable()
    }
  }

  checkForm() {
    if (this.selected.id || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  editItem(event: any) {
  }

  deleteItem(event: any) {
  }

  getAddressByPostalCode(type: 'destination' | 'origin') {
    let postalCode = ''
    if (type == 'destination') {
      postalCode = this.formDestination.get('destinationPostalCode')?.value
    } else if (type == 'origin') {
      postalCode = this.formOrigin.get('originPostalCode')?.value
    }
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response, type)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => { },
      })
    }
  }

  modelLocation(type: 'origin' | 'destination' | '' = '') {
    const origin = this.formOrigin.get('originLocal')?.value ?? ''
    // this.formOrigin.get('originDesc')!.value != ''
    //   ? this.formOrigin.get('originDesc')!.value
    //   : this.generateStateCity('origin')

    const destination = this.formDestination.get('destinationLocal')?.value ?? ''
    // this.formDestination.get('destinationDesc')!.value != ''
    //   ? this.formDestination.get('destinationDesc')!.value
    //   : this.generateStateCity('destination')
    if (type == 'origin') {
      return {
        cep: this.formOrigin.get('originPostalCode')?.value ?? '',
        logradouro: this.formOrigin.get('originStreet')?.value ?? '',
        numero: this.formOrigin.get('originNumber')?.value ?? '',
        bairro: this.formOrigin.get('originNeighborhood')?.value ?? '',
        complemento: this.formOrigin.get('originComplement')?.value ?? '',
        estado: this.formOrigin.get('originState')?.value ?? '',
        cidade: this.formOrigin.get('originCity')?.value ?? '',
        pais: 'Brasil',
        latitude: '',
        longitude: '',
        descricao: origin,
      }
    } else if (type == 'destination') {
      return {
        cep: this.formDestination.get('destinationPostalCode')?.value ?? '',
        logradouro: this.formDestination.get('destinationStreet')?.value ?? '',
        numero: this.formDestination.get('destinationNumber')?.value ?? '',
        bairro:
          this.formDestination.get('destinationNeighborhood')?.value ?? '',
        complemento:
          this.formDestination.get('destinationComplement')?.value ?? '',
        estado: this.formDestination.get('destinationState')?.value ?? '',
        cidade: this.formDestination.get('destinationCity')?.value ?? '',
        pais: 'Brasil',
        latitude: '',
        longitude: '',
        descricao: destination,
      }
    } else {
      // let idOrigin = this.selected.origemId
      //   ? this.selected.origemId
      //   : this.form.get('origin')!.value != ''
      //     ? this.form.get('origin')!.value
      //     : 0
      //
      // let idDestination = this.selected.destinoId
      //   ? this.selected.origemId
      //   : this.form.get('destination')!.value != ''
      //     ? this.form.get('destination')!.value
      //     : 0
      //
      // return this.getStateCity(idOrigin, idDestination)
      return ''
    }
  }

  getStateCity(originId = -1, destinationId = -1) {
    const origin = this.listLocation.find((loc: any) => {
      return loc.id == originId
    })
    const destination = this.listLocation.find((loc: any) => {
      return loc.id == destinationId
    })

    return {
      cityOrigin: origin && origin.cidade ? origin.cidade : '',
      stateOrigin: origin && origin.estado ? origin.estado : '',
      cityDestination:
        destination && destination.cidade ? destination.cidade : '',
      stateDestination:
        destination && destination.estado ? destination.estado : '',
    }
  }

  fillFormViaCep(element: any, type: 'destination' | 'origin') {
    if (type == 'destination') {
      if (element.erro) {
        this.formDestination.get('destinationStreet')?.setValue('')
        this.formDestination.get('destinationNumber')?.setValue('')
        this.formDestination.get('destinationComplement')?.setValue('')
        this.formDestination.get('destinationNeighborhood')?.setValue('')
        this.formDestination.get('destinationCity')?.setValue('')
        this.formDestination.get('destinationState')?.setValue('')
      } else {
        this.formDestination
          .get('destinationStreet')
          ?.setValue(element.logradouro)
        this.formDestination.get('destinationNumber')?.setValue('')
        this.formDestination
          .get('destinationComplement')
          ?.setValue(element.complemento)
        this.formDestination
          .get('destinationNeighborhood')
          ?.setValue(element.bairro)
        this.formDestination
          .get('destinationCity')
          ?.setValue(element.localidade)
        this.formDestination.get('destinationState')?.setValue(element.estado)
        this.searchTariff()
      }
    } else if (type == 'origin') {
      if (element.erro) {
        this.formOrigin.get('originStreet')?.setValue('')
        this.formOrigin.get('originNumber')?.setValue('')
        this.formOrigin.get('originComplement')?.setValue('')
        this.formOrigin.get('originNeighborhood')?.setValue('')
        this.formOrigin.get('originCity')?.setValue('')
        this.formOrigin.get('originState')?.setValue('')
      } else {
        this.formOrigin.get('originStreet')?.setValue(element.logradouro)
        this.formOrigin.get('originNumber')?.setValue('')
        this.formOrigin.get('originComplement')?.setValue(element.complemento)
        this.formOrigin.get('originNeighborhood')?.setValue(element.bairro)
        this.formOrigin.get('originCity')?.setValue(element.localidade)
        this.formOrigin.get('originState')?.setValue(element.estado)
        this.searchTariff()
      }
    }
    // this.getLocationCityState(type)
  }

  getLocationCityState(type: 'destination' | 'origin') {
    let location = {
      cidade: '',
      estado: '',
    }
    if (type == 'origin') {
      location = {
        cidade: this.formOrigin.get('originCity')?.value,
        estado: this.formOrigin.get('originState')?.value,
      }
    } else if (type == 'destination') {
      location = {
        cidade: this.formDestination.get('destinationCity')?.value,
        estado: this.formDestination.get('destinationState')?.value,
      }
    }
    if (location.cidade != '' && location.estado != '') {
      // this.locationService.searchLocationCityState(location).subscribe({
      //   next: (response: any) => {
      //     if (this.isFillingForm) return
      //     if (type == 'origin') {
      //       if (response.data) {
      //         let id = response.data[0].id
      //         const locationObj = this.listLocation.find((loc) => loc.id === id)
      //         if (locationObj) {
      //           this.form
      //             .get('origin')
      //             ?.setValue(locationObj, { emitEvent: false })
      //         } else {
      //           this.form.get('origin')?.setValue('', { emitEvent: false })
      //         }
      //         this.searchTariff()
      //       } else {
      //         this.form.get('origin')?.setValue('', { emitEvent: false })
      //         this.searchTariff()
      //       }
      //     } else if (type == 'destination') {
      //       if (response.data) {
      //         let id = response.data[0].id
      //         const locationObj = this.listLocation.find((loc) => loc.id === id)
      //         if (locationObj) {
      //           this.form
      //             .get('destination')
      //             ?.setValue(locationObj, { emitEvent: false })
      //         } else {
      //           this.form.get('destination')?.setValue('', { emitEvent: false })
      //         }
      //         this.searchTariff()
      //       } else {
      //         this.form.get('destination')?.setValue('', { emitEvent: false })
      //         this.searchTariff()
      //       }
      //     }
      //   },
      //   error: (err: PagedContactTypeResponse) => {},
      //   complete: () => {},
      // })
    }
    this.locationEvent.emit({
      location: this.modelLocation(),
      origin: this.modelLocation('origin'),
      destination: this.modelLocation('destination'),
    })
  }

  googleSearch(type: 'destination' | 'origin') {
    const dialogRef = this.dialog.open(ModalGoogleMapsComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '900px',
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response.insert) {
        this.fillAdress(response.model, type)
      }
    })
  }

  fillAdress(model: any, type: 'destination' | 'origin') {
    if (type == 'destination') {
      this.formDestination.get('destinationPostalCode')?.setValue(model.cep)
      this.formDestination.get('destinationStreet')?.setValue(model.logradouro)
      this.formDestination.get('destinationNumber')?.setValue(model.numero)
      this.formDestination
        .get('destinationComplement')
        ?.setValue(model.complemento)
      this.formDestination
        .get('destinationNeighborhood')
        ?.setValue(model.bairro)
      this.formDestination.get('destinationCity')?.setValue(model.cidade)
      this.formDestination.get('destinationState')?.setValue(model.estado)
      this.formDestination
        .get('destinationLongitude')
        ?.setValue(model.longitude)
      this.formDestination.get('destinationLatitude')?.setValue(model.latitude)
      this.formDestination.get('destinationLocal')?.setValue(model.descricao)
    } else if (type == 'origin') {
      this.formOrigin.get('originPostalCode')?.setValue(model.cep)
      this.formOrigin.get('originStreet')?.setValue(model.logradouro)
      this.formOrigin.get('originNumber')?.setValue(model.numero)
      this.formOrigin.get('originComplement')?.setValue(model.complemento)
      this.formOrigin.get('originNeighborhood')?.setValue(model.bairro)
      this.formOrigin.get('originCity')?.setValue(model.cidade)
      this.formOrigin.get('originState')?.setValue(model.estado)
      this.formOrigin.get('originLongitude')?.setValue(model.longitude)
      this.formOrigin.get('originLatitude')?.setValue(model.latitude)
      this.formOrigin.get('originLocal')?.setValue(model.descricao)
    }
    this.getLocationCityState(type)
    this.searchTariff()
  }

  getDescription(
    id = -1,
    type:
      | 'origin'
      | 'destination'
      | 'serviceType'
      | 'specificationService'
      | 'vehicleType'
      | 'driverType',
  ) {
    let element: any = {}
    switch (type) {
      case 'destination':
        element = this.listLocation.find((ele) => ele.id == id)
        return element && element.descricao ? element.descricao : ''
      case 'origin':
        element = this.listLocation.find((ele) => ele.id == id)
        return element && element.descricao ? element.descricao : ''
      case 'serviceType':
        element = this.listTypeService.find((ele) => ele.id == id)
        return element && element.descricao ? element.descricao : ''
      case 'specificationService':
        element = this.listServiceSpecification.find((ele) => ele.id == id)
        return element && element.descricao ? element.descricao : ''
      case 'driverType':
        element = this.listTypeDriver.find((ele) => ele.id == id)
        return element && element.descricao ? element.descricao : ''
      case 'vehicleType':
        element = this.listTypeVehicle.find((ele) => ele.id == id)
        return element && element.descricao ? element.descricao : ''
      default:
        return ''
    }
  }

  fillPurchase(item: any) {
    if (item.tipoServicoId != this.form.get('serviceType')!.value) {
      this.form.get('serviceType')!.setValue(item.tipoServicoId)
      this.getServiceSpecification(item.tipoServicoId)
    }
    // const originItem = this.listLocation.find((loc) => loc.id === item.origemId)
    // this.form.get('origin')?.setValue(originItem || '', { emitEvent: false })
    //
    // const destinationItem = this.listLocation.find(
    //   (loc) => loc.id === item.destinoId,
    // )
    // this.form
    //   .get('destination')
    //   ?.setValue(destinationItem || '', { emitEvent: false })

    this.form.get('specificationService')!.setValue(item.servicoId)
    this.form.get('tariffType')!.setValue(item.tipoTarifarioId)
    this.form.get('vehicleType')!.setValue(item.tipoVeiculoId ?? 0)
    this.form.get('driverType')!.setValue(item.tipoMotoristaId ?? 0)

    if (item.origin) {
      this.formOrigin.get('originPostalCode')?.setValue(item.origin.cep)
      this.formOrigin.get('originStreet')?.setValue(item.origin.logradouro)
      this.formOrigin.get('originNumber')?.setValue(item.origin.numero)
      this.formOrigin.get('originComplement')?.setValue(item.origin.complemento)
      this.formOrigin.get('originNeighborhood')?.setValue(item.origin.bairro)
      this.formOrigin.get('originCity')?.setValue(item.origin.cidade)
      this.formOrigin.get('originState')?.setValue(item.origin.estado)
      // this.formOrigin.get('originDesc')?.setValue(item.origin.descricao)
      this.formOrigin.get('originLocal')?.setValue(item.origin.descricao)
      this.formOrigin.get('originLatitude')?.setValue(item.origin.latitude)
      this.formOrigin.get('originLogitude')?.setValue(item.origin.longitude)
    }

    if (item.destination) {
      this.formDestination
        .get('destinationPostalCode')
        ?.setValue(item.destination.cep)
      this.formDestination
        .get('destinationStreet')
        ?.setValue(item.destination.logradouro)
      this.formDestination
        .get('destinationNumber')
        ?.setValue(item.destination.numero)
      this.formDestination
        .get('destinationComplement')
        ?.setValue(item.destination.complemento)
      this.formDestination
        .get('destinationNeighborhood')
        ?.setValue(item.destination.bairro)
      this.formDestination
        .get('destinationCity')
        ?.setValue(item.destination.cidade)
      this.formDestination
        .get('destinationState')
        ?.setValue(item.destination.estado)
      // this.formDestination
      //   .get('destinationDesc')
      //   ?.setValue(item.destination.descricao)
      this.formDestination
        .get('destinationLocal')
        ?.setValue(item.destination.descricao)
      this.formOrigin
        .get('destinationLatitude')
        ?.setValue(item.destination.latitude)
      this.formOrigin
        .get('destinationLogitude')
        ?.setValue(item.destination.longitude)
    }
    this.searchTariff()
  }

  createPurchase() {
    const origin = this.generateStateCity('origin')
    // let origin = ''
    // this.formOrigin.get('originDesc')!.value != ''
    //   ? this.formOrigin.get('originDesc')!.value
    //   : this.generateStateCity('origin')
    const destination = this.generateStateCity('destination')
    // let destination = ''
    // this.formDestination.get('destinationDesc')!.value != ''
    //   ? this.formDestination.get('destinationDesc')!.value
    //   : this.generateStateCity('destination')

    const model = {
      // origem: this.getDescription(
      //   this.form.get('origin')!.value != ''
      //     ? this.form.get('origin')!.value
      //     : 0,
      //   'origin',
      // ),
      // destino: this.getDescription(
      //   this.form.get('destination')!.value != ''
      //     ? this.form.get('destination')!.value
      //     : 0,
      //   'destination',
      // ),
      origem: origin,
      destino: destination,
      tipoServico: this.getDescription(
        this.form.get('serviceType')!.value != ''
          ? this.form.get('serviceType')!.value
          : 0,
        'serviceType',
      ),
      servico: this.getDescription(
        this.form.get('specificationService')!.value != ''
          ? this.form.get('specificationService')!.value
          : 0,
        'specificationService',
      ),
      tipoVeiculo: this.getDescription(
        this.form.get('vehicleType')!.value != ''
          ? this.form.get('vehicleType')!.value
          : 0,
        'vehicleType',
      ),
      tipoMotorista: this.getDescription(
        this.form.get('driverType')!.value != ''
          ? this.form.get('driverType')!.value
          : 0,
        'driverType',
      ),

      // origemId:
      //   this.form.get('origin')!.value &&
      //   typeof this.form.get('origin')!.value === 'object'
      //     ? this.form.get('origin')!.value.id
      //     : this.form.get('origin')!.value || 0,
      // destinoId:
      //   this.form.get('destination')!.value &&
      //   typeof this.form.get('destination')!.value === 'object'
      //     ? this.form.get('destination')!.value.id
      //     : this.form.get('destination')!.value || 0,
      origemId: 0,
      destinoId: 0,
      tipoServicoId:
        this.form.get('serviceType')!.value != ''
          ? this.form.get('serviceType')!.value
          : 0,
      servicoId:
        this.form.get('specificationService')!.value != ''
          ? this.form.get('specificationService')!.value
          : 0,
      tipoVeiculoId:
        this.form.get('vehicleType')!.value != '' &&
          this.form.get('vehicleType')!.value != null
          ? this.form.get('vehicleType')!.value
          : 0,
      tipoMotoristaId:
        this.form.get('driverType')!.value != '' &&
          this.form.get('driverType')!.value != null
          ? this.form.get('driverType')!.value
          : 0,
      tipoTarifarioId:
        this.form.get('tariffType')!.value != ''
          ? this.form.get('tariffType')!.value
          : 0,

      location: this.modelLocation(),
      origin: this.modelLocation('origin'),
      destination: this.modelLocation('destination'),
      perimetroUrbano:
        this.form.get('urbanPerimeter')!.value == 'N' ? 'N' : 'S',
    }

    return model
  }

  generateStateCity(type: 'destination' | 'origin') {
    if (type == 'destination') {
      const city = this.formDestination.get('destinationCity')!.value
      const state = this.formDestination.get('destinationState')!.value
      return `${city} - ${this.getUF(state)}`
    } else if (type == 'origin') {
      const city = this.formOrigin.get('originCity')!.value
      const state = this.formOrigin.get('originState')!.value
      return `${city} - ${this.getUF(state)}`
    }
    return ''
  }

  getUF(state: string) {
    const stateFind = this.stateCity.find((ele: any) => {
      return (
        removeAccentsAndSpacesAndLowercase(ele.estado) ==
        removeAccentsAndSpacesAndLowercase(state)
      )
    })
    if (stateFind && stateFind.UF) {
      return stateFind.UF
    } else {
      return ''
    }
  }
}
